export default "__VITE_ASSET__we0XGaD6__"